import notificationService from "@/integration/application/service/notification.service.ts";
import { QUERY_KEYS } from "@integration/factory/queryKeys.ts";
import { PaginationResponse } from "@/integration/application/interfaces/base.ts";
import { Notifications } from "@/integration/application/interfaces/notification.interface.ts";

/**
 * Factory function for notification query options
 * Creates and returns query options for notification-related queries
 */
const notificationQueryOptions = () => {
  const { getAllNotification, getAllNotificationUnred } = notificationService();

  /**
   * Options for fetching paginated notifications with infinite scrolling
   */
  const optionsFetchInfinitNotifications = () => {
    return {
      queryKey: QUERY_KEYS.NOTIFICATION.list,
      queryFn: async ({ pageParam }: { pageParam: number }) => {
        const result = await getAllNotification(pageParam, 8); // Pass both page and limit parameters
        return result as PaginationResponse<Notifications>;
      },
      initialPageParam: 1,
      getNextPageParam: (lastPage: PaginationResponse<Notifications>) => {
        return lastPage.totalPage !== lastPage.page
          ? lastPage.page + 1
          : undefined;
      },
    };
  };

  /**
   * Options for fetching all unread notifications
   */
  const optionsFetchAllNotificationUnred = (isAuthenticated: boolean) => ({
    queryKey: QUERY_KEYS.NOTIFICATION.unread,
    queryFn: getAllNotificationUnred,
    enabled: isAuthenticated,
  });

  return {
    optionsFetchInfinitNotifications,
    optionsFetchAllNotificationUnred,
  };
};

export const {
  optionsFetchInfinitNotifications,
  optionsFetchAllNotificationUnred,
} = notificationQueryOptions();
